/**
 * /devhub/rag — RAG context (operator). Surface Layer (/01). REQ-001.91 DevHub UI rebuild · Phase 3.
 * Live operator panel (DevHubRagContextPanel) wired to its useDevHub* hook over GET /api/control/registry/:name.
 * Operator-only (routePolicy plane guard + DevHubPanelPage self-guard).
 */
import { createFileRoute } from '@tanstack/react-router';
import { DevHubRagContextPanel } from '../features/control-plane/DevHubRagContextPanel';
import { DevHubPanelPage } from '../components/devhub/DevHubPanelPage';

export const Route = createFileRoute('/devhub/rag')({ component: RagPage });

function RagPage() {
  return (
    <DevHubPanelPage
      title="RAG context"
      subtitle="Local RAG corpus and retrieval profiles."
      status={{ label: 'live', live: true }}
    >
      <DevHubRagContextPanel />
    </DevHubPanelPage>
  );
}
